import { render, staticRenderFns } from "./rdaccountlog.vue?vue&type=template&id=564d7864&"
import script from "./rdaccountlog.vue?vue&type=script&lang=js&"
export * from "./rdaccountlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports